import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { colors } from 'src/styles/theme';

const LoadingBackdrop = ({ loading }) => {
  return (
    <>
      <Backdrop
        data-cy="loading-backdrop"
        sx={{ color: colors.white, zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress />
      </Backdrop>
    </>
  );
};

export default LoadingBackdrop;
